import type { Account } from '@mattoespresso/brew-firestore';

import { useMemo } from 'react';
import { useCollection } from 'react-firebase-hooks/firestore';
import { or, query, where, collection } from 'firebase/firestore';

import { ROLES } from 'src/lib/consts';
import { FIRESTORE } from 'src/lib/firebase';

export function useManagers() {
  const [value, loading, error] = useCollection(
    query(
      collection(FIRESTORE, 'account'),
      or(
        where('role', '==', ROLES.MANAGER),
        where('role', '==', ROLES.SUPER_ADMIN),
        where('role', '==', ROLES.INSIGHTS)
      )
    ),
    {
      snapshotListenOptions: { includeMetadataChanges: true },
    }
  );

  const data = useMemo<Account[]>(() => {
    if (loading) {
      return [];
    }

    return value?.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    })) as Account[];
  }, [loading, value]);

  return { data, loading, error };
}
